
window.language = {
	short: "it",
	full: "it-IT",
	tld: "it"
},
window.strings = {
  passenger:{
    one:"Passeggero",
    other:"Passeggeri"
  },
  place:{
    one:"Luogo",
    other:"Luoghi"
  },
  errors:{
    was_not_successful:"non ha avuto successo",
    without_a_valid_address:"senza un indirizzo valido"
  },
  chart: {
    active:{
      one:"partecipante",
      other:"partecipanti"},
    not_active:{
      one:"non partecipante",
      other:"non partecipanti"}
  },
  DataTable: {
    url:"//cdn.datatables.net/plug-ins/1.10.25/i18n/Italian.json",
    print:'Stampa'}
}